<style lang="less" scoped>
  .content {
    position: relative;
    width: 100%;
  }
  .progress {
    position: absolute;
    bottom: 0;
    right: 50%;
    transform: translateX(50%);
  }
  .image-area {
    width: 100%;
    height: 100%;
    display: flex;
  }
  .vertical-row {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    align-items: center;
    padding: 24px 0;
  }
  .draggable-row {
    .image-slot {
      .image-panel-component {
        background-color: white;
      }
    }
  }
  .image-slot {
    width: 72px;
    height: 72px;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 20px;
    &.used {
      .image-panel-component {
        display: none;
      }
    }
    &.active {
      box-shadow: 0 0 15px rgba(255, 0, 0, 1);
    }
    &.filled {
      background-color: white;
    }
  }
  .image-panel-component {
    width: 100%;
    height: 100%;
    margin-bottom: 20px;
    &.empty {
      opacity: .4;
    }
  }
</style>

<template lang="pug">
  .std-layout
    .header
      header-component(
        @click-stop='redirectBack'
        @click-complete='done')
    .content
      .image-area
        .draggable-row.vertical-row
          .image-slot(
            v-for='(data, key) in suffled'
            v-if='payload.indexOf(data) === -1'
            :class='{ used: payload.indexOf(data) !== -1 }'
            @click='use(data)')
            image-panel-component.image-panel-component(:image='data')
          .image-slot(v-else)
            image-panel-component.image-panel-component
        .droppable-row.vertical-row
          .image-slot(
            v-for='(data, key) in displayPayload'
            v-if='!data'
            :class='{ active: key === selected }'
            @click='setSelect(key)')
            image-panel-component.image-panel-component
          .image-slot.filled(
            v-else
            @click='clearPayloadColumn(page * units + key)')
            image-panel-component.image-panel-component(:image='data')
      progress-component.progress(
        :current='page + 1'
        :max='groupCount'
        :unit='"행"')
    .footer
      footer-component(
        :time='time'
        :last='isLast'
        @click-prev='prev'
        @click-next='next'
        @click-complete='done')
</template>

<script>
import HeaderComponent from '@/components/header/stop_complete';
import ImagePanelComponent from '@/components/image_panel';
import ProgressComponent from '@/components/current_max_progress';
import FooterComponent from '@/components/footer/timer_arrow';

export default {
  data() {
    return {
      page: 0,
      selected: 0,
      payload: [],
      display: [],
      displayPayload: [],
      time: 0,
      suffledAll: [],
      suffled: [],
    };
  },
  methods: {
    getSuffled() {
      const result = [];
      const start = this.page * this.units;
      const end = start + this.units;
      for (let i = start; i < end; i += 1) {
        if (!this.suffledAll[i]) {
          break;
        }
        const suffled = this.suffledAll[i];
        result.push(suffled);
      }
      return result;
    },
    getSuffledAll() {
      const result = [];
      const groupCount = Math.ceil(this.answer.length / this.units);
      for (let i = 0; i < groupCount; i += 1) {
        const answerRow = [];
        const start = i * this.units;
        const end = start + this.units;
        for (let j = start; j < end; j += 1) {
          const answer = this.answer[j];
          if (!answer) {
            break;
          }
          answerRow.push(answer);
        }
        while (answerRow.length) {
          const rand = Math.floor(Math.random() * answerRow.length);
          result.push(answerRow[rand]);
          answerRow.splice(rand, 1);
        }
      }
      return result;
    },
    redirectBack() {
      this.$router.go(-1);
    },
    progressTimer() {
      this.time += 1;
      if (this.time >= this.endTime) {
        this.done();
      }
    },
    done() {
      this.$store.commit('setInput', this.payload);
      this.$router.replace({ name: 'TrainingImageResult' });
    },
    setSelect(index) {
      this.selected = index;
    },
    use(value) {
      const page = this.page; // 현재 페이지
      const units = this.units; // 현재 게임에서 최대로 다루는 이미지의 갯수
      const selected = this.selected;
      const index = (page * units) + selected;

      this.$set(this.payload, index, value);
      this.nextSelected();
    },
    nextSelected() {
      if (this.selected < this.units - 1) {
        this.selected += 1;
      } else {
        this.selected = 0;
      }
    },
    clearPayloadColumn(index) {
      this.$set(this.payload, index, null);
    },
    clearFocus() {
      this.selected = null;
    },
    prev() {
      if (this.page > 0) {
        this.page -= 1;
      }
    },
    next() {
      if (this.page + 1 < this.groupCount) {
        this.page += 1;
      }
    },
    getDisplay() {
      const result = [];
      const start = this.page * this.units;
      const end = start + this.units;
      for (let i = start; i < end; i += 1) {
        if (!this.answer[i]) {
          break;
        }
        result.push(this.answer[i]);
      }
      return result;
    },
    getDisplayPayload() {
      const result = [];
      const start = this.page * this.units;
      const end = start + this.units;
      for (let i = start; i < end; i += 1) {
        // 실제 답안은 8개인데 9번째 빈칸이 생성되는 것을 막기 위함.
        const answer = this.answer[i];
        if (!answer) {
          break;
        }
        result.push(this.payload[i]);
      }
      return result;
    },
  },
  watch: {
    page() {
      this.display = this.getDisplay();
      this.displayPayload = this.getDisplayPayload();
      this.suffled = this.getSuffled();
      this.selected = 0;
    },
    payload() {
      this.displayPayload = this.getDisplayPayload();
    },
  },
  computed: {
    isLast() {
      return this.groupCount - 1 === this.page;
    },
    units() {
      return this.$store.state.app.units;
    },
    endTime() {
      return this.$store.state.app.recall * 60;
    },
    // display() {
    //   const result = [];
    //   const start = this.page * this.units;
    //   const end = start + this.units;
    //   for (let i = start; i < end; i += 1) {
    //     if (!this.answer[i]) {
    //       break;
    //     }
    //     result.push(this.answer[i]);
    //   }
    //   return result;
    // },
    // displayPayload() {
    //   const result = [];
    //   const start = this.page * this.units;
    //   const end = start + this.units;
    //   for (let i = start; i < end; i += 1) {
    //     result.push(this.payload[i]);
    //   }
    //   return result;
    // },
    // suffled() {
    //   const result = [];
    //   const start = this.page * this.units;
    //   const end = start + this.units;
    //   for (let i = start; i < end; i += 1) {
    //     if (!this.suffledAll[i]) {
    //       break;
    //     }
    //     const suffled = this.suffledAll[i];
    //     result.push(suffled);
    //   }
    //   return result;
    // },
    answer() {
      return this.$store.state.app.answer;
    },
    groupCount() {
      return Math.ceil(this.answer.length / this.units);
    },
  },
  mounted() {
    window.intervalID = setInterval(this.progressTimer, 1000);
    this.display = this.getDisplay();
    this.displayPayload = this.getDisplayPayload();
    this.suffledAll = this.getSuffledAll();
    this.suffled = this.getSuffled();
  },
  beforeDestroy() {
    clearInterval(window.intervalID);
  },
  components: {
    HeaderComponent,
    ImagePanelComponent,
    ProgressComponent,
    FooterComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/image/recall.vue